export const isHuaweiWebview = () =>
  !!navigator?.userAgent?.toLowerCase?.()?.includes('androidapp');
